import EditAssociationInformation from './EditAssociationInformation.page';

export default EditAssociationInformation;